/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FenceResultPost } from '../../models/fence-result-post';

export interface FenceResultPost$Params {
  raceGuid: string;
  timestamp: string;
      body: Array<FenceResultPost>
}

export function fenceResultPost(http: HttpClient, rootUrl: string, params: FenceResultPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, fenceResultPost.PATH, 'post');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.query('timestamp', params.timestamp, {"style":"form"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

fenceResultPost.PATH = '/races/{raceGuid}/fenceresults';
